<div
  bsModal
  #pickerDlg="bs-modal"
  class="modal my-modal-wrapper fade"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3>People Picker</h3>
        <a style="height: 30px" class="circle close" (click)="pickerDlg.hide()">
          <mat-icon>close</mat-icon>
        </a>
      </div>
      <div class="modal-body" style="height: 580px; overflow-y: auto">
        <div class="container-fluid">
          <div
            class="btn-group"
            role="group"
            aria-label="Basic radio toggle button group"
            *ngIf="isSecurity()"
          >
            <input
              type="radio"
              class="btn-check"
              value="1"
              (click)="memberTypeChanged(1)"
              id="btnUser"
              [checked]="memberType === 1"
            />
            <label class="btn btn-outline-secondary" for="btnUser">Users</label>

            <input
              type="radio"
              class="btn-check"
              value="2"
              (click)="memberTypeChanged(2)"
              id="btnGroup"
              [checked]="memberType === 2"
            />
            <label class="btn btn-outline-secondary" for="btnGroup">Groups</label>

            <input
              type="radio"
              class="btn-check"
              value="0"
              (click)="memberTypeChanged(0)"
              id="btnAny"
              [checked]="memberType === 0"
            />
            <label class="btn btn-outline-secondary" for="btnAny">Both</label>
          </div>
          <search-box
            #box
            placeHolder="Search for members..."
            [searchCriteria]="searchCriteria"
            (searchCriteriaChanged)="updateSearchCriteria($event)"
            [options]="{ showFilterBtn: false, triggerSearchOnChange: true}"
          >
          </search-box>
          <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
            <em class="material-icons">warning</em>
            <span class="sr-only">Error:</span>
            {{errorMsg}}
          </div>
        </div>
        <div *ngIf="!errorMsg && people">
          <div class="list-group">
            <a
              class="list-group-item"
              *ngFor="let person of people"
              (click)="select(person)"
              [class.disabled]="isSelected(person)"
            >
              <em
                class="fa"
                [ngClass]="{
                'fa-user': person.type == 'User',
                'fa-users': person.type == 'Group'
              }"
              ></em>
              {{ person.cai}} {{person.displayName}}
            </a>
          </div>
          <pager
            [items]="people.paging"
            (pageChanged)="pageChanged($event)"
            [options]="{shouldShowFirstPageLink: true, shouldShowNextPageLink: true, shouldShowPreviousPageLink: true, shouldShowLastPageLink: true}"
          >
          </pager>
        </div>
      </div>
      <div class="modal-footer">&nbsp;</div>
    </div>
  </div>
</div>
